// GlobalContainer.product() returns "archived", "agent", "default", etc.
// The API only accepts "recruiting" or "retention".
const normalizeProduct = (product) => {
  if (product === "retention") return "retention";
  if (product === "recruiting" || product === "archived" || product === "agent")
    return "recruiting";
  return null;
};

export default normalizeProduct;
